import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['link']

  connect() {
    this.updateActiveItem()
  }

  updateActiveItem() {
    const THRESHOLD = 300
    const headings = this.linkTargets
      .map(link => document.querySelector(link.getAttribute('href')))
      .filter(el => el !== null)

    let closestHeading = null
    let closestOffset = Number.POSITIVE_INFINITY

    headings.forEach(heading => {
      const rect = heading.getBoundingClientRect()
      const offset = Math.abs(rect.top)

      if (rect.top <= THRESHOLD && offset < closestOffset) {
        closestOffset = offset
        closestHeading = heading
      }
    })

    if (closestHeading) this.setActiveLink(closestHeading.id)
  }

  setActiveLink(activeId) {
    this.linkTargets.forEach(link => {
      link.dataset.active = link.getAttribute('href') === `#${activeId}`
    })
  }
}
